import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

// CSS imports
import './index.css';
import './globalStyling.css';
import '@dotlottie/react-player/dist/index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

// Provider imports
import ViewportProvider from './providers/ViewportProvider';
import ThemeProvider from './providers/ThemeProvider';

// Helper imports
import ScrollTopWrapper from './helpers/components/scrollTopWrapper/ScrollTopWrapper';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router>
      <ScrollTopWrapper>
        <ViewportProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </ViewportProvider>
      </ScrollTopWrapper>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
